import authenticationControl from './authenticationControl.js';
$('#login').click(function () {
    authenticationControl.signIn();
});

authenticationControl.initLoginPage(true);